import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import {
  InsurerUserInputDto,
  InsurerUserPreviewDto,
  InsurerUserSearchResultDto,
} from "../interfaces/admin/InsurerUser";

const apiEndpoint = "/insurerUser";

const getInsurerUsersAsync = async (query: string): Promise<AxiosResponse<Array<InsurerUserSearchResultDto>>> => {
  return await http.get<Array<InsurerUserSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getInsurerUsersCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getInsurerUserAsync = async (id: number): Promise<AxiosResponse<InsurerUserPreviewDto>> => {
  return await http.get<InsurerUserPreviewDto>(`${apiEndpoint}/${id}`);
};

const addInsurerUserAsync = async (model: InsurerUserInputDto): Promise<AxiosResponse<InsurerUserInputDto>> => {
  return await http.post<InsurerUserInputDto>(apiEndpoint, model);
};

const updateInsurerUserAsync = async (model: InsurerUserInputDto): Promise<AxiosResponse<InsurerUserInputDto>> => {
  return await http.put<InsurerUserInputDto>(`${apiEndpoint}/${model.insurerUserId}`, model);
};

export default {
  getInsurerUsersAsync,
  getInsurerUsersCountAsync,
  getInsurerUserAsync,
  addInsurerUserAsync,
  updateInsurerUserAsync,
};
